<script>
import LoadOnDemand from 'comp/modules/LoadOnDemand.vue'
import DialogModules from 'comp/modules/DialogModules'

import { mapGetters } from 'vuex'
import { getPublicityHousing } from '@/api/pageData'
import { themeConfigureImgUrl } from '@/utils/common'

export default {
  components: { LoadOnDemand, DialogModules },
  data() {
    return {
      currentCommunity: localStorage.getItem('currentCommunity'),
      pageData: [],
      currentModule: {},
      currentModuleItemDataId: 0,
      currentModuleItemDataHeadline: ''
    }
  },
  computed: {
    ...mapGetters({
      getCurrentNavObj: 'config/getCurrentNavObj',
      currentModalNameGetter: 'config/getCurrentModalName',
      screenSizeGetter: 'config/getScreenSize'
    }),
    currentNavObj() { return this.getCurrentNavObj },
    currentModalName() { return this.currentModalNameGetter },
    screenSize: {
      get() {
        return this.screenSizeGetter
      }
    }
  },
  watch: {
    screenSize(newVal, oldVal) {
      this.$nextTick(() => {
        const enlarge_dom = document.getElementById('pulic-main-content')
        enlarge_dom.style.transform = `scale(${newVal})`
        enlarge_dom.style.transformOrigin = '0 0'
      })
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    themeConfigureImgUrl,
    onCheckDetail(v) {
      this.currentModule = v
      this.$store.commit('config/SET_CURRENT_MODALNAME', v.title)
      this.$store.commit('config/SET_CURRENT_MODULE_ID', v.id)
      const whiteList = [15, 61, 66]
      if (whiteList.includes(v.id)) return
      this.$store.commit('config/SET_DIALOG', true)
    },
    onModuleItem(v) {
      this.currentModuleItemDataId = v?.id || 0
      this.currentModuleItemDataHeadline = v?.headline || ''
    },

    initPageData() {
      const params = {
        village: this.currentCommunity,
        title: this.currentNavObj.templateName,
        userid: localStorage.getItem('screenUserid') || 0,
        tid: this.currentNavObj.id
      }
      getPublicityHousing(params).then(res => {
        if (res.code === 0) this.pageData = res.msg
      })
    }
  }
}
</script>

<template>
  <div
    class="page-used-style publicity-housing"
    :style="{
      background: `url(${themeConfigureImgUrl(currentNavObj.pageBg)}) no-repeat center`,
      backgroundSize: '100% 100%'
    }"
  >
    <div class="enlarge-box">
      <div id="pulic-main-content" class="pulic-main-content">
        <load-on-demand
          v-for="(v, i) in pageData"
          :key="`load-demand-${i}`"
          :page-data-obj="v.list[0]"
          @click.native="onCheckDetail(v.list[0])"
          @onModuleItem="onModuleItem"
        />
      </div>
    </div>

    <Dialog>
      <template #content-main>
        <dialog-modules
          v-if="currentModalName"
          :current-module="currentModule"
          :current-module-item-data-id="currentModuleItemDataId"
          :current-module-item-data-headline="currentModuleItemDataHeadline"
        />
      </template>
    </Dialog>
  </div>
</template>

<style lang="scss" scoped>
.publicity-housing {
  .pulic-main-content {
    width: 1500px;
    height: 944px;
    overflow-y: scroll;
    padding: 35px 0;
    box-sizing: border-box;
    transition: all .2s ease-in;

    display: flex;
    flex-wrap: wrap;
    column-gap: 65px;
    row-gap: 60px;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }
}
.top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .neighborhood-committee {
    width: 440px;
    height: 410px;
  }
  .supervise-member {
    width: 448px;
    height: 430px;
  }
  .hb-council {
    width: 480px;
    height: 420px;
  }
}
.center {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 47px;
  .sequence-diagram {
    width: 747px;
    height: 380px;
  }
  .resident-representative {
    width: 753px;
    height: 408px;
  }
}
.bottom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 47px;
  .finance-public {
    width: 754px;
    height: 387px;
  }
  .facts {
    width: 758px;
    height: 390px;
  }
}

.img-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  // row-gap: 40px;
  .modal-img {
    width: 1280px;
    height: auto;
  }
}
</style>
